var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"left",style:({ width: true ? _vm.autoWidth + 'px' : '320px' })},[_vm._t("left")],2),_c('div',{staticClass:"center"},[_vm._t("center")],2),(_vm.originalShowRight)?_c('div',{staticClass:"right",style:({ width: _vm.autoWidth + 'px' })},[_vm._t("right")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }